import { $store, $channels } from '@/ts/store';
import './_feedback-modal.scss';
import { SearchableSelect } from '@/ts/utils/custom-select-full';

/* Init Feedback Modal component and enable better accessibility features. */

export default function FeedbackModal() {
    const $target = document.querySelector('.feedback-modal') as HTMLDialogElement;

    if ($target) {
        const $form = $target.querySelector('form')!;
        const $close = $target.querySelector('.close-btn')! as HTMLElement;
        const $questionErrorsWrapper = $target.querySelector('.question#question-errors') as HTMLElement;
        const $questionErrorsRadios = $questionErrorsWrapper.querySelectorAll('input[type="radio"][name="errors"]') as NodeListOf<HTMLInputElement>;
        const $questionErrorsDropdownWrapper = $questionErrorsWrapper.querySelector('[data-select-up-search]') as HTMLElement;
        const $questionErrorsDropdown = $questionErrorsWrapper.querySelector('button.search-select__opener') as HTMLButtonElement;
        const $confirmBtn = $target.querySelector('.confirm.blue-btn') as HTMLElement;
        const storeKey = 'feedback-modal';
        const feedbackState = {
            status: false,
            open,
            close,
            $form,
        };
        $channels.register(storeKey);

        function open() {
            history.replaceState(null, '', window.location.pathname + window.location.search);
            feedbackState.status = true;
            $store.setKey(storeKey, { ...feedbackState });
            $target.showModal();
        }

        function close() {
            feedbackState.status = false;
            $store.setKey(storeKey, { ...feedbackState });
            $target.close();
        }

        function getCheckedInputs() {
            const $questionInputs = $form.querySelectorAll('.question');
            const $checkedInputs = $form.querySelectorAll("input[type='radio']:checked");
            return $questionInputs.length === $checkedInputs.length;
        }

        function init() {
            $store.setKey(storeKey, { ...feedbackState });
            const $infoText = $target.querySelector('.info-text a') as HTMLElement;
            const $link = document.querySelector('.feedback-banner a[href="#feedback"]') as HTMLElement;

            if ($link) {
                $link.setAttribute('role', 'button');
                $link.setAttribute('aria-haspopup', 'dialog');
            }

            if($infoText) {
                $infoText.setAttribute('target', '_blank');
            }

            Array.from($questionErrorsRadios).forEach($questionErrorsRadio => {
                $questionErrorsRadio.addEventListener('change', (event) => {
                    if($questionErrorsRadio.getAttribute('id') === 'errors-no') {
                        $questionErrorsDropdownWrapper.setAttribute('data-disabled', 'true');
                        $questionErrorsDropdown.setAttribute('disabled', 'true');

                        const $select = $questionErrorsWrapper.querySelector('select');
                        if($select) {
                            const $selectPlaceholder = $select.querySelector('option[value="placeholder"]') as HTMLOptionElement;
                            $select.value = $selectPlaceholder ? $selectPlaceholder.value : '';
                            SearchableSelect.update($select.parentElement);
                        }
                    } else {
                        $questionErrorsDropdownWrapper.removeAttribute('data-disabled');
                        $questionErrorsDropdown.removeAttribute('disabled');
                    }
                });
            })

            $close.addEventListener('click', ev => {
                ev.preventDefault();
                close();
            });

            window.addEventListener('hashchange', () => {
                if (window.location.hash === '#feedback') {
                    open();
                }
            });

            $form.addEventListener('submit', ev => {
                ev.preventDefault();
            });

            $form.addEventListener('change', function () {
                if (getCheckedInputs()) {
                    $confirmBtn.removeAttribute('disabled');
                } else {
                    $confirmBtn.setAttribute('disabled', 'true');
                }
            });

            if (window.location.hash === '#feedback') {
                open();
            }
        }

        init();
    }
}
